import { render } from "./BookingPitch.vue?vue&type=template&id=4b282317"
import script from "./BookingPitch.vue?vue&type=script&lang=js"
export * from "./BookingPitch.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "4b282317"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b282317', script)) {
    api.reload('4b282317', script)
  }
  
  module.hot.accept("./BookingPitch.vue?vue&type=template&id=4b282317", () => {
    api.rerender('4b282317', render)
  })

}

script.__file = "src/components/BookingPitch.vue"

export default script